import React from 'react';
import type {TooltipRenderProps} from 'react-joyride';

const OnboardingTooltip: React.FC<TooltipRenderProps> = ({
  index,
  size,
  step,
  backProps,
  primaryProps,
  closeProps,
  skipProps,
  isLastStep,
  continuous,
  tooltipProps,
  hideStepCount,
}: TooltipRenderProps & { hideStepCount?: boolean }) => {
  const title = (step as any).title as string | undefined;

  const primaryLabel = primaryProps?.title || (isLastStep ? 'Finish' : (continuous ? 'Next' : 'Got it'));
  const backLabel = backProps?.title || 'Back';
  const skipLabel = skipProps?.title || 'Skip';

  return (
    <div
      {...tooltipProps}
      className="animate-fade-in modern-joyride-tooltip w-[420px] max-w-[420px] rounded-2xl shadow-xl ring-1 ring-light-border-default/60 dark:ring-slate-700/60 bg-secondary-light dark:bg-tertiary-dark text-light-text-primary dark:text-light-text-inverse overflow-hidden"
      style={{ pointerEvents: "auto", zIndex: 9999 }}
    >
      <div className="px-5 pt-4 pb-3 border-b border-light-border-default/60 dark:border-slate-700/60">
        <div className="flex items-center justify-between gap-3">
          <div>
            {!hideStepCount && (
              <div className="text-xs text-light-text-secondary dark:text-light-text-inverse/70">
                Step {index + 1} of {size}
              </div>
            )}
            {title ? (
              <div className="mt-1 text-sm font-semibold">{title}</div>
            ) : null}
          </div>
          <button
            {...closeProps}
            aria-label="Close"
            className="h-8 w-8 rounded-full border border-light-border-default/60 dark:border-slate-700/60 bg-secondary-light dark:bg-secondary-dark text-light-text-secondary dark:text-light-text-inverse/70 flex items-center justify-center shadow-sm"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              className="h-4 w-4"
            >
              <path
                fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>
      </div>

      <div className="px-5 py-4">
        <div className="prose prose-sm dark:prose-invert max-w-none text-light-text-secondary dark:text-light-text-inverse/80 break-words whitespace-normal max-h-[160px] overflow-y-auto">
          {step.content}
        </div>
      </div>

      <div className="px-5 pb-4">
        <div className="flex items-center justify-between gap-2">
          {skipProps && (
            <button
              type="button"
              {...skipProps}
              className="px-3 py-2 text-xs font-medium rounded-lg border border-light-border-default/60 dark:border-slate-700/60 bg-secondary-light dark:bg-secondary-dark text-light-text-secondary dark:text-light-text-inverse/70"
            >
              {skipLabel}
            </button>
          )}

          <div className="flex items-center gap-2 w-full">
            {/**
            {index > 0 && backProps && (
              <button type="button" {...backProps} className="px-3 py-2 text-xs font-medium rounded-lg border border-light-border-default/60 dark:border-slate-700/60 bg-tertiary-light dark:bg-tertiary-dark text-light-text-secondary dark:text-light-text-inverse/70">
                {backLabel}
              </button>
            )}
            **/}

            {primaryProps && (
              <button
                type="button"
                {...primaryProps}
                className="ml-auto px-3 py-2 text-xs font-semibold rounded-lg bg-primary-light hover:bg-primary-hover text-white shadow-sm"
              >
                {primaryLabel}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingTooltip; 